export const NAVIGATION_PATHS = {
  BASE_PARAMS: '/:orgId/:budgetId',
  HOME: '',
  BUDGET_SUMMARY: 'budgetSummary',
  BUDGET_LINE_ITEM_EDITOR: 'budgetLineItemEditor',
  PROGRAM_INVENTORY: 'programInventory',
  COST_ALLOCATION: 'costAllocation',
  DEPARTMENT_SCORING: 'departmentScoring',
  DEPARTMENT_REVIEW: 'departmentReview',
  PEER_REVIEW: 'peerReview',
  FINAL_REVIEW: 'finalReview',
  DATA_VISUALIZATIONS: 'dataVisualizations',
  PROGRAM_INSIGHTS: 'programInsights',
  BUDGET_REQUESTS: 'budgetRequests',
  REPORTS: 'reports',
  ORGANIZATIONAL_HIERARCHY: 'organizationalHierarchy',
  NAME_CONVENTION: 'nameConvention',
  MANAGE_USERS: 'manageUsers',
  MANAGE_USER_ACCESS: 'manageUserAccess',
  USER_ACTIVITY: 'userActivity',
  CONFIGURE_BUDGET: 'configureBudget',
  CONFIGURE_SCORING: 'configureScoring',
  CONFIGURE_INSIGHTS: 'configureInsights',
  CONFIGURE_REQUESTS: 'configureRequests',
  ORGANIZATION_EDITOR: 'organizationEditor',
  MANAGE_ADMIN_USERS: 'manageAdminUsers',
  MANAGE_ORGANIZATION_ACCESS: 'manageOrganizationAccess',
  MANAGE_DATA: 'manageData',
  PBB_STRATEGIST: 'pbbStrategist',
  USER_PROFILE: 'userProfile',
  SESSION_TIMEOUT: '/sessionTimeout',
  SESSION_ENDED: '/sessionEnded',
  LOGIN: '/login',
  LOGOUT: '/logout',
  LOGIN_FLOW: '/loginFlow',
  UNAUTHORISED_ACCESS: '/unauthorizedAccess',
  COST_BENCHMARK: 'costBenchmark',
  INVALID_URL: '/invalidUrl',
  AI_ANALYTICS: 'aiAnalytics'
};
